<template>
    <b-container>
        <template v-if="!!clientId && !!showNoteForm">
            <b-row>
                <b-col>
                    <b-form-textarea
                        v-model="newNote"
                        placeholder="Texto de la nota"
                        :rows="3"
                        :max-rows="6">
                    </b-form-textarea>
                </b-col>
            </b-row>

            <b-row class="mt-2">
                <b-col class="d-flex justify-content-between">
                    <div>
                        <button class="btn btn-secondary btn-sm" @click="emitFormClosed()">
                            Cerrar
                        </button>
                    </div>

                    <div>
                        <button :disabled="!newNote" class="btn btn-primary btn-sm" @click="saveNewNote()">
                            Añadir
                        </button>
                    </div>
                </b-col>
            </b-row>

            <hr class="my-2">
        </template>

        <template v-if="!!clientId && clientNotes.length">
            <b-row class="note-container pr-2">
                <b-col>
                    <b-row v-for="note in clientNotes" :key="note.uuid" class="mb-2 animated fadeIn">
                        <b-col class="p-2 note">
                            <div class="font-weight-light">
                                <div class="float-right">{{ note.date | dateFormat('DD/MM/YYYY HH:mm') }}</div>
                                <div>{{ note.user }}</div>
                            </div>
                            <hr class="mt-1">
                            <div>{{ note.note }}</div>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </template>

        <template v-else>
            No hay notas
        </template>
    </b-container>
</template>

<script>
    import {getClientNotes, createClientNote} from '@/api/client-note-api';
    import ClientNotesService from '@/services/client/client-notes-service';

    const clientNotesService = new ClientNotesService();

    export default {
        name: "ClientNotesManagement",
        props: {
            clientId: String,
            showNoteForm: Boolean
        },
        data() {
            return {
                clientNotes: [],
                notesType: [],
                noteTypeId: null,
                newNote: null
            }
        },
        created() {
            if (!!this.clientId) {
                this.getNoteType();
                this.getNotes();
            }
        },
        methods: {
            async getNotes() {
                clientNotesService.getNotes(this.clientId)
                    .then((clientNotes) => {
                        this.clientNotes = [];
                        
                        for (var i = 0; i < clientNotes.length; i++) {
                            if (clientNotes[i].noteTypeId == this.noteTypeId) {
                                this.clientNotes.push(clientNotes[i]);
                            }
                        }
                    })
                    .catch((error) => {
                        console.log("No se han podido recuperar las notas del socio" + error);
                    });
            },
            async getNoteType() {
                clientNotesService.getNoteType()
                    .then((notesType) => {
                        this.notesType = notesType;

                        for (var i = 0; i < this.notesType.length; i++) {
                            if (this.notesType[i].name == 'Contabilidad') {
                                this.noteTypeId = this.notesType[i].uuid;
                            }
                        }
                    })
                    .catch((error) => {
                        console.log("No se han podido recuperar los tipos de notas" + error);
                    });
            },
            saveNewNote() {
                this.$_loadingMixin_showLoading();
                clientNotesService.newNote(this.clientId, { note: this.newNote, noteTypeId: this.noteTypeId })
                    .then(() => {
                        this.getNotes();
                        this.showNewNote = false;
                        this.newNote = null;
                        //this.noteTypeId = null;
                        this.$_loadingMixin_hideLoading();
                    })
                    .catch((error) => {
                        this.$_loadingMixin_hideLoading();
                        VueNotifications.error({
                            title: 'Nota no guardada',
                            message: 'Se ha producido algún error y no hemos podido almacenar la nota'
                        });
                    })
            },
            emitFormClosed() {
                this.$emit('note-form-closed');
            }
        },
        watch: {
            clientId: function () {
                if (!!this.clientId) {
                    this.getNotes(this.clientId);
                }
            }
        }
    }
</script>

<style scoped>
    .note {
        background-color: #ECF0F3;
        border-radius: 5px;
    }

    .note-container {
        height: 300px;
        overflow-y: scroll;
    }
</style>